module.exports = __webpack_public_path__ + "static/media/11.dd772876.jpg";